import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconIntegrations: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconIntegrations"><Path d="M1.5 12L9 4.5L16.5 12L9 19.5L1.5 12Z" stroke="currentColor"/><Path d="M12 7.5L15 4.5L22.5 12L15 19.5L12 16.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconIntegrations;
